"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMeasurementToOverride = void 0;
const MeasurementOverride_1 = require("../objects/MeasurementOverride");
function convertMeasurementToOverride(measurement) {
    if (!measurement) {
        throw new Error("Measurement is undefined");
    }
    const measurementOverride = new MeasurementOverride_1.MeasurementOverride();
    measurementOverride.scale = measurement.scale;
    measurementOverride.unit = measurement.unit;
    return measurementOverride;
}
exports.convertMeasurementToOverride = convertMeasurementToOverride;
